<template>
    <div>
        <RouterLink :to="{ name: 'home' }" class="flex items-center w-full lg:w-auto">
            <img
                class="cursor-pointer mr-4"
                src="../assets/images/iiportal-logo.webp"
                alt="logo"
                :class="[small ? 'max-h-[1.5rem]' : 'max-h-[2.5rem] lg:max-h-[3.2rem]']"
            >
        </RouterLink>
    </div>
</template>

<script lang="ts" setup>
    defineProps({
        small: {
            type: Boolean,
            default: false
        }
    })
</script>
